module.exports = __webpack_public_path__ + "static/images/bottom-image-mobile.b1b6e5a5103621c35182d6decd038881.png";